(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4323],{

/***/ 40341:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden")}
function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;__webpack_unused_export__=h;__webpack_unused_export__=z;__webpack_unused_export__=A;__webpack_unused_export__=B;__webpack_unused_export__=C;__webpack_unused_export__=D;__webpack_unused_export__=E;__webpack_unused_export__=F;__webpack_unused_export__=G;__webpack_unused_export__=H;
__webpack_unused_export__=I;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(a){return y(a)===h};__webpack_unused_export__=function(a){return y(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return y(a)===k};__webpack_unused_export__=function(a){return y(a)===d};__webpack_unused_export__=function(a){return y(a)===p};__webpack_unused_export__=function(a){return y(a)===n};
__webpack_unused_export__=function(a){return y(a)===c};__webpack_unused_export__=function(a){return y(a)===f};__webpack_unused_export__=function(a){return y(a)===e};__webpack_unused_export__=function(a){return y(a)===l};__webpack_unused_export__=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
__webpack_unused_export__=y;


/***/ }),

/***/ 65122:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  /* unused reexport */ __webpack_require__(40341);
} else {}


/***/ }),

/***/ 62089:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/show-rooms",
      function () {
        return __webpack_require__(33870);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 17946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Zx": function() { return /* binding */ Font; },
  "ZP": function() { return /* binding */ showRooms_ShowRoomItem; }
});

// UNUSED EXPORTS: FontSize

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./common/MediaQueries.tsx + 5 modules
var MediaQueries = __webpack_require__(57402);
// EXTERNAL MODULE: ./common/analytics.ts + 10 modules
var analytics = __webpack_require__(87018);
// EXTERNAL MODULE: ./common/bit/NextLink.tsx
var NextLink = __webpack_require__(60687);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./theme/shared.tsx
var shared = __webpack_require__(6089);
// EXTERNAL MODULE: ./components/mapPages/CardRowText.tsx
var CardRowText = __webpack_require__(94316);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Link/Link.js
var Link = __webpack_require__(89659);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/mapPages/showRooms/ManagerBox.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  img {\n    border-radius: 50%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        " !important;\n  text-decoration: underline;\n  cursor: pointer;\n  p {\n    color: ",
        " !important;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var StyledContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ManagerBox__StyledContent",
    componentId: "sc-2691e267-0"
})(_templateObject());
var StyledSmallText = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "body2"
}).withConfig({
    displayName: "ManagerBox__StyledSmallText",
    componentId: "sc-2691e267-1"
})(_templateObject1(), function(p) {
    return p.$bold ? "bold" : "300";
});
var StyledLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    displayName: "ManagerBox__StyledLink",
    componentId: "sc-2691e267-2"
})(_templateObject2(), function(p) {
    return p.theme.colors.saphire;
}, function(p) {
    return p.theme.colors.saphire;
});
var ManagerBox = function(param) {
    var showRoom = param.showRoom;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (showRoom === null || showRoom === void 0 ? void 0 : showRoom.managerName) && (showRoom === null || showRoom === void 0 ? void 0 : showRoom.managerEmail) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContent, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: showRoom.managerImage ? showRoom.managerImage.imageUrl : "/img/managerPlaceholder.png",
                    alt: showRoom.managerImage ? showRoom.managerImage.alt : "manager",
                    width: 50,
                    height: 50,
                    objectFit: "cover",
                    priority: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        (showRoom === null || showRoom === void 0 ? void 0 : showRoom.managerName) && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSmallText, {
                            children: showRoom === null || showRoom === void 0 ? void 0 : showRoom.managerName
                        }),
                        showRoom.managerEmail && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            href: "mailto:".concat(showRoom.managerEmail),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSmallText, {
                                children: showRoom === null || showRoom === void 0 ? void 0 : showRoom.managerEmail
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var showRooms_ManagerBox = (ManagerBox);

;// CONCATENATED MODULE: ./components/mapPages/showRooms/ShowRoomItem.tsx

function ShowRoomItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0px 0px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  background-color: ",
        ";\n  padding: 20px 15px;\n  border-radius: 6px;\n  border: 1.5px solid\n    ",
        ";\n  ",
        " {\n    flex-direction: row;\n  }\n"
    ]);
    ShowRoomItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ShowRoomItem_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  ",
        " {\n    width: 50%;\n  }\n"
    ]);
    ShowRoomItem_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ShowRoomItem_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 0;\n  display: inline-block;\n"
    ]);
    ShowRoomItem_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  align-items: start;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: auto;\n  flex-grow: 1;\n  flex-shrink: 0;\n  background-color: ",
        ";\n  width: 0.5px;\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: -4px;\n  margin-top: -1px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}










var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ShowRoomItem__StyledWrapper",
    componentId: "sc-4736824-0"
})(ShowRoomItem_templateObject(), function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.$selected ? p.theme.colors.saphire : p.theme.colors.transparent;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledColumn = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ShowRoomItem__StyledColumn",
    componentId: "sc-4736824-1"
})(ShowRoomItem_templateObject1(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledHeadline = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "h3"
}).withConfig({
    displayName: "ShowRoomItem__StyledHeadline",
    componentId: "sc-4736824-2"
})(ShowRoomItem_templateObject2());
var StyledContentStart = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ShowRoomItem__StyledContentStart",
    componentId: "sc-4736824-3"
})(_templateObject3());
var StyledDivider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ShowRoomItem__StyledDivider",
    componentId: "sc-4736824-4"
})(_templateObject4(), function(p) {
    return p.theme.colors.darkGrey;
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledIcon = (0,styled_components_browser_esm/* default */.ZP)(shared/* StyledSvgIcon */.vV).withConfig({
    displayName: "ShowRoomItem__StyledIcon",
    componentId: "sc-4736824-5"
})(_templateObject5());
var StyledButtonWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ShowRoomItem__StyledButtonWrap",
    componentId: "sc-4736824-6"
})(_templateObject6());
var StyledMobileIcon = (0,styled_components_browser_esm/* default */.ZP)(shared/* StyledSvgIcon */.vV).withConfig({
    displayName: "ShowRoomItem__StyledMobileIcon",
    componentId: "sc-4736824-7"
})(_templateObject7(), function(p) {
    return (p === null || p === void 0 ? void 0 : p.$left) && "left: ".concat(p.$left, "px;");
}, function(p) {
    return (p === null || p === void 0 ? void 0 : p.$top) && "top: ".concat(p.$top, "px;");
}, function(p) {
    return (p === null || p === void 0 ? void 0 : p.$flip) && "transform: rotateY(180deg);";
});
var Font;
(function(Font) {
    Font["OENaPro"] = "OENaPro";
    Font["MazdaType"] = "MazdaType, OENaPro, sans serif";
})(Font || (Font = {}));
var FontSize;
(function(FontSize) {
    FontSize[FontSize["small"] = 16] = "small";
    FontSize[FontSize["large"] = 18] = "large";
})(FontSize || (FontSize = {}));
var ShowRoomItem = function(param) {
    var showRoom = param.showRoom, isShowRoomSelected = param.isShowRoomSelected;
    var ref = (0,react.useRef)(null);
    if (isShowRoomSelected) {
        var ref1;
        (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.scrollIntoView({
            block: "nearest"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        $selected: isShowRoomSelected,
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledColumn, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Desktop */.Hi, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIcon, {
                            src: "/icons/mazdaLocationIcon.svg",
                            w: 32,
                            h: 40
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeadline, {
                        children: showRoom === null || showRoom === void 0 ? void 0 : showRoom.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardRowText/* default */.Z, {
                        data: showRoom.address,
                        iconName: "mazdaLocationIcon",
                        iconInMobile: true,
                        font: Font.OENaPro,
                        fontSize: FontSize.large
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardRowText/* default */.Z, {
                        data: showRoom.whatsapp,
                        link: "https://api.whatsapp.com/send/?phone=972532397240&text&type=phone_number&app_absent=0",
                        iconName: "whatsappLogo",
                        font: Font.MazdaType,
                        fontSize: FontSize.small
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardRowText/* default */.Z, {
                        data: showRoom.phone,
                        link: "tel:".concat(showRoom.phone),
                        iconName: "phoneCall",
                        font: Font.MazdaType,
                        fontSize: FontSize.small,
                        trackEvent: analytics/* trackPhoneShowroomPageClicks */.ib
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Desktop */.Hi, {
                        children: showRoom.fax && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardRowText/* default */.Z, {
                            data: showRoom.fax,
                            iconName: "fax",
                            font: Font.MazdaType,
                            fontSize: FontSize.small
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDivider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledColumn, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Desktop */.Hi, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* StyledSvgIcon */.vV, {
                            src: "/icons/clock.svg",
                            w: 35,
                            h: 35
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContentStart, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Mobile */.ij, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* StyledSvgIcon */.vV, {
                                    src: "/icons/clock.svg"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeadline, {
                                        children: "שעות פעילות"
                                    }),
                                    showRoom.stringShowRoomsSchedule.map(function(openingHour, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* StyledRow */.N0, {
                                            $mt: "7px",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardRowText/* default */.Z, {
                                                data: openingHour,
                                                font: Font.OENaPro,
                                                fontSize: FontSize.large
                                            })
                                        }, index);
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(showRooms_ManagerBox, {
                        showRoom: showRoom
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Mobile */.ij, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(shared/* StyledRow */.N0, {
                    $gap: "10px",
                    $fullWidth: true,
                    children: [
                        showRoom.wazeLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonWrap, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                href: showRoom.wazeLink,
                                openInNewTab: true,
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                    variant: "outlined",
                                    fullWidth: true,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMobileIcon, {
                                            src: "/icons/navigationArrow.svg",
                                            w: 15,
                                            h: 15,
                                            $left: 5,
                                            $top: 1,
                                            $flip: true
                                        }),
                                        "ניווט ב-Waze"
                                    ]
                                })
                            })
                        }),
                        showRoom.phone && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonWrap, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                href: "tel:".concat(showRoom.phone),
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                    variant: "outlined",
                                    fullWidth: true,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMobileIcon, {
                                            src: "/icons/phoneCall.svg",
                                            w: 18,
                                            h: 18,
                                            $left: 5
                                        }),
                                        "חיוג"
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var showRooms_ShowRoomItem = (/*#__PURE__*/(0,react.memo)(ShowRoomItem));


/***/ }),

/***/ 33870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ show_rooms; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./api/index.ts + 2 modules
var api = __webpack_require__(71537);
// EXTERNAL MODULE: ./common/analytics.ts + 10 modules
var analytics = __webpack_require__(87018);
// EXTERNAL MODULE: ./common/bit/NextLink.tsx
var NextLink = __webpack_require__(60687);
// EXTERNAL MODULE: ./common/MediaQueries.tsx + 5 modules
var MediaQueries = __webpack_require__(57402);
// EXTERNAL MODULE: ./hooks/useGeolocation.ts
var useGeolocation = __webpack_require__(17942);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./reusable/icons/CalendarIcon.tsx
var CalendarIcon = __webpack_require__(21919);
// EXTERNAL MODULE: ./reusable/wrappers/InnerPageWrapper.tsx
var InnerPageWrapper = __webpack_require__(45732);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./theme/colors.ts
var colors = __webpack_require__(22038);
// EXTERNAL MODULE: ./reusable/popups/ErrorLocationPopUp.tsx
var ErrorLocationPopUp = __webpack_require__(28114);
// EXTERNAL MODULE: ./reusable/TwoToggleButtons.tsx
var TwoToggleButtons = __webpack_require__(70498);
// EXTERNAL MODULE: ./components/mapPages/AreSelectionButtons.tsx
var AreSelectionButtons = __webpack_require__(62573);
// EXTERNAL MODULE: ./components/mapPages/map/DynamicMap.tsx + 1 modules
var DynamicMap = __webpack_require__(66166);
// EXTERNAL MODULE: ./components/mapPages/map/MapContext.tsx + 1 modules
var MapContext = __webpack_require__(95887);
// EXTERNAL MODULE: ./components/mapPages/map/utils/mapFilters.ts
var mapFilters = __webpack_require__(1719);
// EXTERNAL MODULE: ./components/mapPages/showRooms/ShowRoomItem.tsx + 1 modules
var ShowRoomItem = __webpack_require__(17946);
;// CONCATENATED MODULE: ./components/mapPages/showRooms/ShowRoomList.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  width: 100%;\n  height: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var StyledList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    displayName: "ShowRoomList__StyledList",
    componentId: "sc-c55e719d-0"
})(_templateObject());
var StyledListItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    displayName: "ShowRoomList__StyledListItem",
    componentId: "sc-c55e719d-1"
})(_templateObject1());
var ShowRoomList = function() {
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    var ref = (0,MapContext/* useMapContext */.fx)(), selectedStore = ref.selectedStore, filterStores = ref.filterStores, onStoreClick = ref.onStoreClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledList, {
        children: !!(filterStores === null || filterStores === void 0 ? void 0 : filterStores.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: filterStores.map(function(item, i) {
                return isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledListItem, {
                    tabIndex: 0,
                    role: "button",
                    onClick: function() {
                        onStoreClick(item);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowRoomItem/* default */.ZP, {
                        showRoom: item,
                        isShowRoomSelected: (selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.id) === (item === null || item === void 0 ? void 0 : item.id)
                    })
                }, i) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledListItem, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowRoomItem/* default */.ZP, {
                        showRoom: item,
                        isShowRoomSelected: (selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.id) === (item === null || item === void 0 ? void 0 : item.id)
                    })
                }, i);
            })
        })
    });
};
/* harmony default export */ var showRooms_ShowRoomList = (/*#__PURE__*/(0,react.memo)(ShowRoomList));

;// CONCATENATED MODULE: ./components/mapPages/showRooms/ShowRoomsPage.tsx



function ShowRoomsPage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  [class*="StyledSubtitle"] {\n    max-width: 540px;\n    margin: 20px auto 0;\n  }\n'
    ]);
    ShowRoomsPage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ShowRoomsPage_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding-top: 20px;\n  width: 100%;\n"
    ]);
    ShowRoomsPage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  /* .MuiButton-label {\n    gap: 10px;\n    display: flex;\n    align-items: center;\n  } */\n  &:hover,\n  &:focus-visible {\n    path {\n      stroke: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  justify-content: space-between;\n  background-color: ",
        ";\n  padding: 16px;\n  border-radius: 4px;\n  width: 100%;\n  margin-top: 40px;\n  gap: 20px;\n  ",
        " {\n    flex-direction: row;\n    align-items: center;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    width: 320px;\n    margin: 0;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 20px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  direction: ltr;\n  > * {\n    direction: rtl;\n  }\n  ",
        " {\n    width: 50%;\n    flex-shrink: 0;\n    height: 680px;\n    overflow-y: auto;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n  flex-shrink: 0;\n  width: 50%;\n  height: 680px;\n  position: sticky;\n  /* top: var(--sticky-height); */\n  transition: top 221ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  align-self: flex-start;\n  padding: 0px 25px;\n  padding-left: 0;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



















var StyledInnerPageWrapper = (0,styled_components_browser_esm/* default */.ZP)(InnerPageWrapper/* default */.Z).withConfig({
    displayName: "ShowRoomsPage__StyledInnerPageWrapper",
    componentId: "sc-27d9462d-0"
})(ShowRoomsPage_templateObject());
var StyledContentWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ShowRoomsPage__StyledContentWrap",
    componentId: "sc-27d9462d-1"
})(ShowRoomsPage_templateObject1());
var StyledMeetingButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    displayName: "ShowRoomsPage__StyledMeetingButton",
    componentId: "sc-27d9462d-2"
})(_templateObject2(), function(p) {
    return p.theme.colors.white;
}, colors/* default.white */.Z.white);
var StyledToggleWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ShowRoomsPage__StyledToggleWrapper",
    componentId: "sc-27d9462d-3"
})(_templateObject3(), function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledTwoToggleButtons = (0,styled_components_browser_esm/* default */.ZP)(TwoToggleButtons/* default */.Z).withConfig({
    displayName: "ShowRoomsPage__StyledTwoToggleButtons",
    componentId: "sc-27d9462d-4"
})(_templateObject4(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledAreSelectionButtons = (0,styled_components_browser_esm/* default */.ZP)(AreSelectionButtons/* default */.Z).withConfig({
    displayName: "ShowRoomsPage__StyledAreSelectionButtons",
    componentId: "sc-27d9462d-5"
})(_templateObject5());
var StyledContentSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "ShowRoomsPage__StyledContentSection",
    componentId: "sc-27d9462d-6"
})(_templateObject6(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledMapSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "ShowRoomsPage__StyledMapSection",
    componentId: "sc-27d9462d-7"
})(_templateObject7());
var ShowRoomsPage = function() {
    var ref = (0,MapContext/* useMapContext */.fx)(), setStores = ref.setStores, stores = ref.stores, setMap = ref.setMap, setMaps = ref.setMaps, setFilterStores = ref.setFilterStores, setSelectedStore = ref.setSelectedStore;
    // todo change to local storage:
    var ref1 = (0,react.useState)(false), userHasSeenPopUpError = ref1[0], setUserHasSeenPopUpError = ref1[1];
    var ref2 = (0,react.useState)(false), openErrorPopUp = ref2[0], setOpenErrorPopUp = ref2[1];
    // toggle states:
    var ref3 = (0,react.useState)(mapFilters/* ToggleButtons.CLOSE_TO_ME */.s0.CLOSE_TO_ME), toggleIndex = ref3[0], setToggleIndex = ref3[1];
    var ref4 = (0,react.useState)(mapFilters/* Areas.ALL */.Bg.ALL), selectedAreaId = ref4[0], setSelectedAreaId = ref4[1];
    // location states:
    var ref5 = (0,useGeolocation/* default */.Z)(), loaded = ref5.loaded, error = ref5.error, lng = ref5.lng, lat = ref5.lat;
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    // if user allow location and we have coordinates (lat,lng) call the api
    (0,react.useEffect)(function() {
        var isComponentMounted = true;
        if (error.code != "" && !userHasSeenPopUpError) {
            setOpenErrorPopUp(true);
        }
        var fetchData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var data;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!isComponentMounted) return [
                                3,
                                2
                            ];
                            if (!(loaded && lng && lat)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                (0,api/* getShowroomAll */.jz)(lng, lat).then(api/* extractData */.Kj)
                            ];
                        case 1:
                            data = _state.sent();
                            setStores(data === null || data === void 0 ? void 0 : data.body);
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData().catch(console.error);
        return function() {
            isComponentMounted = false;
        };
    }, [
        error,
        loaded,
        lng,
        lat
    ]);
    (0,react.useEffect)(function() {
        //Filter options updated so apply all filters here
        var result = stores;
        result = (0,mapFilters/* locationFilterListShowRooms */._D)(result, selectedAreaId, toggleIndex);
        setFilterStores(result);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        stores,
        selectedAreaId,
        toggleIndex
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledInnerPageWrapper, {
            title: "אולמות התצוגה של מאזדה",
            subtitle: "מוזמנים להתארח באולמות התצוגה שלנו, להתרשם מהדגמים מקרוב וליהנות מהחוויה המלאה של מאזדה",
            imgUrl: isDesktop ? "/img/cover/Showrooms.jpg" : "/img/cover/Showroomsmobile.jpg",
            breadCrumbName: "ShowRooms",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                    href: "/meeting/",
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMeetingButton, {
                        variant: "outlined",
                        onClick: function() {
                            (0,analytics/* trackPopUpOpen */.W1)("showrooms meeting");
                        },
                        startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CalendarIcon/* default */.Z, {
                            width: 24,
                            height: 24,
                            color: colors/* default.black */.Z.black
                        }),
                        children: "לבחירת דגם ותיאום פגישה"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledToggleWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body1",
                            component: "h2",
                            children: "חפשו אולמות תצוגה לפי המיקום שלכם, וקבלו מידע על שעות פעילות, דרכי הגעה ועוד"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTwoToggleButtons, {
                            activeButton: toggleIndex,
                            setActiveButton: setToggleIndex,
                            optionsList: [
                                "קרוב אליי",
                                "לפי אזור"
                            ],
                            toggleId: "map-toggle"
                        })
                    ]
                }),
                toggleIndex === mapFilters/* ToggleButtons.AREAS */.s0.AREAS && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAreSelectionButtons, {
                    activeButton: selectedAreaId,
                    setActiveButton: setSelectedAreaId,
                    onSelectFunction: function() {
                        return setSelectedStore(null);
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContentWrap, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContentSection, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(showRooms_ShowRoomList, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Desktop */.Hi, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMapSection, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicMap/* default */.Z, {
                                    setMaps: setMaps,
                                    setMap: setMap
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorLocationPopUp/* default */.Z, {
                    open: openErrorPopUp,
                    setOpen: setOpenErrorPopUp,
                    setUserHasSeenPopUpError: setUserHasSeenPopUpError
                })
            ]
        })
    });
};
/* harmony default export */ var showRooms_ShowRoomsPage = (ShowRoomsPage);

// EXTERNAL MODULE: ./common/SeoMetaData.tsx
var SeoMetaData = __webpack_require__(25384);
;// CONCATENATED MODULE: ./src/pages/show-rooms.tsx




var ShowRooms = function(param) {
    var pageData = param.pageData, seo = param.seo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoMetaData/* default */.ZP, {
                data: seo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MapContext/* MapContextProvider */.sf, {
                itemList: pageData,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(showRooms_ShowRoomsPage, {})
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var show_rooms = (ShowRooms);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5229,161,9774,2888,179], function() { return __webpack_exec__(62089); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);